/*
 * TreeBase  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import RcTree, { TreeProps as RcTreeProps, TreeNodeProps as RcTreeNodeProps } from "rc-tree";

export interface ITreeBaseProps extends RcTreeProps {}

export interface ITreeBaseNodeProps extends RcTreeNodeProps {}

export const TreeBase: React.FC<ITreeBaseProps> = (props) => <RcTree {...props} />;
